import React from "react";

const ClockIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="#48454E"
    fillOpacity="0.5"
    {...props}
  >
    <path d="M12.75 13.9167L13.9167 12.7501L10.8334 9.66675V5.83342H9.16669V10.3334L12.75 13.9167ZM10 18.3334C8.84724 18.3334 7.76391 18.1147 6.75002 17.6772C5.73613 17.2397 4.85419 16.6459 4.10419 15.8959C3.35419 15.1459 2.76044 14.264 2.32294 13.2501C1.88544 12.2362 1.66669 11.1529 1.66669 10.0001C1.66669 8.8473 1.88544 7.76397 2.32294 6.75008C2.76044 5.73619 3.35419 4.85425 4.10419 4.10425C4.85419 3.35425 5.73613 2.7605 6.75002 2.323C7.76391 1.8855 8.84724 1.66675 10 1.66675C11.1528 1.66675 12.2361 1.8855 13.25 2.323C14.2639 2.7605 15.1459 3.35425 15.8959 4.10425C16.6459 4.85425 17.2396 5.73619 17.6771 6.75008C18.1146 7.76397 18.3334 8.8473 18.3334 10.0001C18.3334 11.1529 18.1146 12.2362 17.6771 13.2501C17.2396 14.264 16.6459 15.1459 15.8959 15.8959C15.1459 16.6459 14.2639 17.2397 13.25 17.6772C12.2361 18.1147 11.1528 18.3334 10 18.3334ZM10 16.6667C11.8472 16.6667 13.4202 16.0174 14.7188 14.7188C16.0174 13.4202 16.6667 11.8473 16.6667 10.0001C16.6667 8.15286 16.0174 6.57994 14.7188 5.28133C13.4202 3.98272 11.8472 3.33341 10 3.33341C8.1528 3.33341 6.57988 3.98272 5.28127 5.28133C3.98266 6.57994 3.33335 8.15286 3.33335 10.0001C3.33335 11.8473 3.98266 13.4202 5.28127 14.7188C6.57988 16.0174 8.1528 16.6667 10 16.6667Z" />
  </svg>
);

export default ClockIcon;
